var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-calendar-item__data-item",class:_vm.overbookedClass},[_vm._v(" "+_vm._s(_vm.remaining)+" "),(_vm.priorityBookingCount)?_c('span',[_vm._v(" (優先 "+_vm._s(_vm.priorityBookingCount)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }